import { render, staticRenderFns } from "./LLTextareaEmoji.vue?vue&type=template&id=1875b8d0&scoped=true"
import script from "./LLTextareaEmoji.vue?vue&type=script&lang=js"
export * from "./LLTextareaEmoji.vue?vue&type=script&lang=js"
import style0 from "./LLTextareaEmoji.vue?vue&type=style&index=0&id=1875b8d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1875b8d0",
  null
  
)

export default component.exports